import { computed, observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";
import Notice, { SignatureType } from "./notice";
import type { IVehicle } from "./types";
import { CountryIdValidationRules, LicensePlateValidationRules } from "./orderItem";

export const NoticeTechnicalLicenseRules: EntityValidationRules<Notice> = {
  _technicalLicenseFilesBase64: {
    requiredIf: {
      condition: (entity: Notice) => entity._signatureType === SignatureType.DataBox,
      customMessage: "documentUploadRequired",
    },
  },
};
export default class LicensePlateChange extends Notice implements IVehicle {
  @observable
  licensePlate?: string;

  @observable
  countryId?: string;

  @observable
  originalVehicle?: IVehicle;

  @observable
  newVehicle?: IVehicle;

  @computed
  get rules(): EntityValidationRules<LicensePlateChange> {
    return {
      ...LicensePlateValidationRules,
      ...CountryIdValidationRules,
      ...NoticeTechnicalLicenseRules,
    };
  }
}
